import React from 'react';
import styles from './Toggle.module.css';
import { InfoTooltip, TooltipPosition } from '../../molecules/InfoTooltip';

export enum ToggleSize {
  SMALL = 'small',
  LARGE = 'large',
}

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  isDisabled: boolean;
  label?: string;
  tooltipText?: string;
  uniqueKey: string;
}

const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  isDisabled,
  label,
  tooltipText,
  uniqueKey,
}) => {
  const inputId = `${uniqueKey}-toggle-input`;
  const tooltipId = `${uniqueKey}-toggle-tooltip`;

  return (
    <div className={styles.toggleContainer}>
      {/* Toggle and label */}
      <label htmlFor={inputId} className={styles.labelWrapper}>
        <div
          className={`${styles.toggle} ${checked ? styles.checked : ''} ${
            isDisabled
              ? checked
                ? styles['toggle--disabled-on']
                : styles['toggle--disabled-off']
              : ''
          }`}
        >
          <input
            id={inputId}
            type='checkbox'
            checked={checked}
            onChange={e => {
              onChange(e.target.checked);
            }}
            className={styles.input}
            disabled={isDisabled}
          />
          <span
            className={isDisabled ? styles.sliderDisabled : styles.slider}
          />
        </div>
        {label && (
          <span className={styles.labelText}>
            <span
              className={isDisabled ? styles['toggle--disabled-label'] : ''}
            >
              {label}
            </span>
          </span>
        )}
      </label>

      {tooltipText && (
        <InfoTooltip
          id={tooltipId}
          content={tooltipText}
          tooltipPosition={TooltipPosition.TOP_LEFT}
          classes={styles.toggle__tooltip}
        />
      )}
    </div>
  );
};

export default Toggle;
